<template>
  <div>
    <div class="py-2">
      <div class="d-flex justify-content-between">
        <button type="button" class="btn btn-sm btn-primary" @click="prevTemplate()">
          <i class="fa fa-chevron-left"></i>
        </button>
        <span class="text-muetd mt-1 small">{{ currentTemplate + 1 }} / {{ templates.length }}</span>
        <button type="button" class="btn btn-sm btn-primary" @click="nextTemplate()">
          <i class="fa fa-chevron-right"></i>
        </button>
      </div>
    </div>
    <div id="cover-editor">
      <div class="cover-editor" v-if="distribution" style="position: relative;">
        <span style="display:none;">CSS_STYLE_HERE</span>
        <div class="editor-background" style="background-position: center center; background-repeat: no-repeat; background-size: cover; height: 100%; overflow: hidden; width: 100%;">
          <img @load="loading = false" v-if="templates[currentTemplate]" :src="templates[currentTemplate].url" width="2000" height="2000" crossorigin>
          <div class="cover-loader text-center" v-if="loading">
            <i class="fa fa-spinner fa-spin text-muted" style="margin-top: 45%; font-size: 150px !important;"></i>
          </div>
        </div>
        <div class="cover-editor-text" :style="`text-align: ${textAlign}; padding: 150px; position: absolute; left: 0; top: ${textAlign === 'left' ? 0 : '20%'}; width: 100%; font-family: ${font || 'Source Sans Pro'}, 'Helvetica Neue', Helvetica, Arial, sans-serif; color: ${textColor}; text-shadow: 3px 3px 10px rgba(0, 0, 0, 0.5);`">
          <div class="cover-editor-title" :style="`font-size: ${titleSize}px; line-height: ${titleSize * 1}px; font-weight: bold; width: 1700px;`">
            {{ distribution.title }}
          </div>
          <div class="cover-editor-artist" :style="`font-size: ${artistSize}px; line-height: ${artistSize * 0.9}px; font-weight: normal; margin-top: ${artistSize/2}px; width: 1700px;`">
            {{ distribution.artist.name }} {{ featuring }}
          </div>
        </div>
      </div>
    </div>
    <canvas id="cover-canvas" width="2000" height="2000" style="display: none;"></canvas>
  </div>
</template>
<script>
import Distribution from '../services/distributions'
import _ from 'underscore'

export default {
  name: 'CoverEditor',
  props: ['distribution', 'textAlign', 'font', 'titleSize', 'artistSize'],
  data: function () {
    return {
      loading: true,
      textColor: '#ffffff',
      currentTemplate: 0,
      templates: []
    }
  },
  computed: {
    featuring: function () {
      let featuringText = ''
      let featuringArtist = []
      let featuringArtistArr = []

      let primaryArtistText = ''
      let primaryArtists = []
      let primaryArtistArr = []

      if (this.distribution.songs && this.distribution.songs.length === 1) {
        if (this.distribution.songs[0].featuring) {
          if (typeof this.distribution.songs[0].featuring === 'string') {
            featuringText = `feat. ${this.distribution.songs[0].featuring}`
          } else {
            primaryArtists = _.filter(this.distribution.songs[0].featuring, item => item.primaryArtist)
            featuringArtist = _.filter(this.distribution.songs[0].featuring, item => !item.primaryArtist)

            if (primaryArtists.length > 0) {
              _.each(primaryArtists, (item) => {
                primaryArtistArr.push(item.name.trim())
              })
              primaryArtistText += '& ' + primaryArtistArr.join(' & ') + ' '
            }

            if (featuringArtist.length > 0) {
              featuringText = 'feat. '
              _.each(featuringArtist, (item) => {
                featuringArtistArr.push(item.name.trim())
              })
              featuringText += featuringArtistArr.join(', ')
            }
          }
        }
      }
      return primaryArtistText + featuringText
    }
  },
  methods: {
    prevTemplate: function () {
      this.loading = true

      if (this.currentTemplate > 0) {
        this.currentTemplate--
      } else {
        this.currentTemplate = this.totalTemplates - 1
      }

      this.$eventBus.$emit('updateCoverCode', this.currentTemplate)
    },
    nextTemplate: function () {
      this.loading = true

      if (this.currentTemplate < (this.totalTemplates - 1)) {
        this.currentTemplate++
      } else {
        this.currentTemplate = 0
      }

      this.$eventBus.$emit('updateCoverCode', this.currentTemplate)
    }
  },
  created: function () {
    Distribution.getCovers().then(response => {
      let covers = response.data
      let baseUrl = `/s3assets/cover-templates/`

      if (location.host.match(/localhost/)) {
        baseUrl = `https://indiefy.net/s3assets/cover-templates/`
      }

      _.each(covers, item => {
        this.templates.push({
          url: `${baseUrl}${item.full.split('/').pop()}`,
          preview: `${baseUrl}${item.small.split('/').pop()}`,
          coverId: item.number
        })
      })

      this.totalTemplates = this.templates.length

      if (this.distribution.cover_image_code !== undefined) {
        this.currentTemplate = parseInt(this.distribution.cover_image_code)

        if (!this.templates[this.currentTemplate]) {
          this.currentTemplate = 0
        }
      } else {
        this.currentTemplate = Math.floor(Math.random() * (this.totalTemplates - 1))
        this.$eventBus.$emit('updateCoverCode', this.currentTemplate)
      }

      this.$forceUpdate()
    })
  }
}
</script>
<style lang="scss" scoped>
.cover-editor {
  background-color: #eee;
  width: 2000px;
  height: 2000px;
  display: inline-block;
  transform: scale(0.2);
  transform-origin: 0 0;
}

@media screen and (max-width:576px) {
  .cover-editor {
    transform: scale(0.135);
  }
}

.cover-loader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: white;
  z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/components/CoverEditor.vue